/** eslint-disable prettier/prettier */
import { Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class CronogramaService {
    
    statusIdList: { [key: string]: string } = {
        "1": "STATUS_ACTIVE",
        "2": "STATUS_WAITING",
        "3": "STATUS_SUSPENDED",
        "4": "STATUS_DONE",
        "5": "STATUS_FAILED",
        "6": "STATUS_UNDEFINED"
    };
    
    statusListToId: { [key: string]: string } = {
        "STATUS_ACTIVE": "1",
        "STATUS_WAITING": "2",
        "STATUS_SUSPENDED": "3",
        "STATUS_DONE": "4",
        "STATUS_FAILED": "5",
        "STATUS_UNDEFINED": "6"
    };

    statusList = {
        "STATUS_ACTIVE": { label: 'No prazo', color: '#008000' },
        "STATUS_DONE": { label: 'Concluído', color: '#0073E6' },
        "STATUS_FAILED": { label: 'Atrasada', color: '#CA2D21' },
        "STATUS_SUSPENDED": { label: 'Suspensa', color: '#764D4A' },
        "STATUS_WAITING": { label: 'Não iniciado', color: '#909dad' },
        "STATUS_UNDEFINED": { label: 'Não informada', color: '#cfd5dc' }
    };
    statusBaseLine = {
        "STATUS_ACTIVE": { label:'Normal', color:'#8ba33e', icon:'label_important' },
        "STATUS_DONE": { label:'Concluído', color:'#0073E6', icon:'check_box' },
        "STATUS_ALERT": { label:'Requer atenção', color:'#e8d166', icon:'change_history' },
        "STATUS_LATE": { label:'Com problemas', color:'#c1374b', icon:'square' },
        "STATUS_DONE_LATE": { label:'Concluído com atraso', color:'#36589d', icon:'check_circle_unread' },
        "STATUS_WAITING": { label:'Não iniciado', color:'#909dad', icon:'hourglass_top' },
        "STATUS_SUSPENDED":  { label:'Cancelado', color:'#764D4A', icon:'timer_pause' },
    };
    constructor() { }

    //logica principal temporariamente desativada pois está sendo usado uma rotina em JAVA
    generateAllStatus(tasks) {
        const modTasks = tasks.map(task => {
            const status = this.generateStatus(task, tasks);
            return {...task, status1:this.statusListToId[status]}
        });

        console.log(modTasks);

        return modTasks;
        // const newTasks = this.orderByDeps(tasks);
        // const modTasks = newTasks.map(task => {
        //     const status = this.generateStatus(task,newTasks);
        //     return {...task, status:status };
        // });

        // const pfTasks = tasks.map(t => {
        //     t.status = this.findStatusInFlat(t, modTasks);

        //     if (t.pf_prt_issue_childs.length > 0) {
        //         t.pf_prt_issue_childs = this.recursiveStatusInTask(t.pf_prt_issue_childs, modTasks);
        //     }

        //     return t;
        // });

        // return pfTasks;
    }

    findStatusInFlat(t, tasks): string {
        var pf = tasks.find(m => t.id == m.id);

        return pf?.status ?? 'STATUS_UNDEFINED';
    }

    recursiveStatusInTask(childs, tasks) {
        var updChilds = childs.map(c => {
            if (c.pf_prt_issue_childs.length > 0) {
                c.pf_prt_issue_childs = this.recursiveStatusInTask(c.pf_prt_issue_childs, tasks);
            }

            c = {...c, status:this.findStatusInFlat(c, tasks) };

            return c;
        });

        return updChilds;
    }

    orderByDeps(tasks) {
        const flat = [];
        const stack = [...tasks];
        while (stack.length) {
            const t = stack.pop();
            flat.push(t);
            if (t.pf_prt_issue_childs) stack.push(...t.pf_prt_issue_childs);
        }

        console.log(flat);

        const sorted = [];
        const added = new Set();
        while (sorted.length < flat.length) {
            for (const t of flat) {
                if (added.has(t.code) && sorted.includes(t)) continue;
                const deps = String(t.depends || '')
                    .split(',')
                    .map(s => +s.trim())
                    .filter(Boolean);
                if (deps.every(d => added.has(d) || !d)) {
                    console.log(t.code, 6);
                    sorted.push(t);
                    added.add(+t.code);
                }
            }
        }
        console.log(sorted);
        return flat;
    }

    generateStatus(task, allTasks) {
        try {
            if (task.canceled) return 'STATUS_SUSPENDED';

            const deps = String(task.depends || '')
                .split(',')
                .map(s => +s.trim())
                .filter(Boolean);

            for (const dep of deps) {
                const depTask = allTasks.find(t => +t.code === dep);
                if (depTask?.progress >= 100) {
                    depTask.status = 'STATUS_DONE';
                }
                if (depTask && depTask?.status !== 'STATUS_DONE') {
                    return 'STATUS_WAITING';
                }
            }

            if (!task.dt_start || !task.dt_conclusion){
                return 'STATUS_UNDEFINED';
            }

            const today = new Date();
            const conclusion = new Date(task.dt_conclusion);

            if (task.progress >= 100) {
                return 'STATUS_DONE';
            }
            if (conclusion > today){
                return 'STATUS_ACTIVE';
            }
            return 'STATUS_FAILED';
        } catch {
            return 'STATUS_UNDEFINED';
        }
    }

    generateStatusBaseline(task,baselinePercents){

        if (task.canceled) {
            return 'STATUS_SUSPENDED';
        }

        const now = new Date();
        const taskStart = new Date(task?.start);
        // console.log(task.id, task)
        const taskEnd = new Date(task.end);
        const baselineStart = new Date(task.start_baseline);
        const baselineEnd = new Date(task.end_baseline);

        const toDateOnly = (date: Date): Date =>
            new Date(date.getFullYear(), date.getMonth(), date.getDate());

        if (task.progress >= 100) {
            if (toDateOnly(taskEnd).getTime() > toDateOnly(baselineEnd).getTime()) {
                return 'STATUS_DONE_LATE'; // concluída com atraso
            } else {
                return 'STATUS_DONE'; // concluída no prazo
            }
        }

        if (now.getTime() > toDateOnly(baselineEnd).getTime() && task.progress < 100) {
            return 'STATUS_LATE';
        }

        if (baselineStart > now) {
            return 'STATUS_WAITING';
        } else {
            /*
            // dias planejados
            const plannedDuration = Math.max(baselineEnd.getTime() - baselineStart.getTime(), 1);
            const plannedDays = plannedDuration / (1000 * 60 * 60 * 24);

            // dias já passados desde o início
            const elapsedTime = Math.max(now.getTime() - baselineStart.getTime(), 0);
            const elapsedDays = elapsedTime / (1000 * 60 * 60 * 24);

            // porcentagem do tempo até agora
            const elapsedPercent = Math.min((elapsedDays * 100) / plannedDays, 100);

            // progresso real
            const progress = Number(task.progress) || 0;

            // performance (progresso comparado ao tempo esperado)
            const performance = elapsedPercent > 0 ? (progress / elapsedPercent) * 100 : 100;
            */
            const progress = parseFloat(task.progress) || 0;
            const performance = (task?.foreseen_executed > 0) ? (progress / task?.foreseen_executed) * 100 : 100;
            
            if (performance >= +baselinePercents.ok) {
                return 'STATUS_ACTIVE';
            } else if (performance >= +baselinePercents.warn) {
                return 'STATUS_ALERT';
            } else {
                return 'STATUS_LATE';
            }
        }
    }

    getByNrod(ord, list){
        for (const item of list) {
            if (+item.code == +ord) {
                return item;
            }
            var find =  this.getByNrod(ord, item['pf_prt_issue_childs']);
            if(find) {
                return find;
            }
        }
        return null;
    }
}